import { FC } from 'react';

import { CustomNextImage as Image } from '@crehana/next';

import { ImageWrapper } from './Resource.styles';

type ImageResourceProps = {
  coverUrl: string;
};

const ImageResource: FC<ImageResourceProps> = ({ coverUrl }) => {
  return (
    <ImageWrapper className="md:mr-24 md:w-7/12">
      <Image
        src={coverUrl}
        alt="Resource"
        layout="responsive"
        className="rounded-10 w-full"
        height={200}
        width={375}
        quality={100}
        objectFit="contain"
      />
    </ImageWrapper>
  );
};

export default ImageResource;
